module.exports = "//public.getcloudapp.com/packs/media/images/icons-hidden-fe8b6407925e7a87581c40257c4c1b43.svg";